export const optionsData = [
  {
    name: "Registered Investment Advisor",
    title: "The Complete Tech Stack for Scaling RIA Practice",
    descriptions: [
      "Monitor AUM, client growth, and revenue in one dashboard",
      "Offer goal-based planning, model portfolios, and investment recommendations",
      "Use Gridkey as your digital backend for client onboarding, documentation, and client engagement",
      "Stay ready for SEBI audits with all advice logs, documents, and approvals logged in one place.",
      "Automate fee invoicing and payment tracking",
    ],
    imgSrc: "/LandingPage/ria.png",
  },
  {
    name: "Research Analyst",
    title:
      "One Platform to Publish, Onboard, and Monetize Your Investment Ideas",
    descriptions: [
      "Create and publish investment baskets with rationale and disclosures on branded microwebsite.",
      "Fully digitized onboarding with KYC, agreement signing, risk profiling and payments.",
      "Collect subscription fees and automate renewal collections with ease",
      "Enable users to execute model investments and rebalances orders via 18+ top brokers in India with 4 clicks.",
      "Stay compliant with auto-managed audit logs, activity history, client interactions and disclosures.",
    ],
    imgSrc: "/LandingPage/ra.png",
  },
  {
    name: "Portfolio Management Services",
    title: "Powering India’s Next Generation of PMS Fund Managers",
    descriptions: [
      "Generate performance reports with XIRR, NAV, TWRR, benchmark comparisons",
      "Integrate with custodians, RTAs, and brokers for seamless pre- and post-trade workflows.",
      "Unified dashboard across portfolios, clients, and distributors",
      "Comply with PMS regulations — documentation, agreement tracking, audit readiness",
      "Publish performance reports to clients along with offering web and mobile logins to clients",
    ],
    imgSrc: "/LandingPage/pms.png",
  },
  {
    name: "Sub-Brokers",
    title: "Plug-and-Play Advisory Tech for Broker Ecosystems",
    descriptions: [
      "Convert your infra into an all-in-one wealth execution & advisory suite.",
      "Offer an advisory stack bundled with your execution stack",
      "Give your sub-brokers an edge with advisory-ready infra",
      "Keep all order histories, trade logs, and actions audit-ready.",
    ],
    imgSrc: "/LandingPage/subBroker.png",
  },
  {
    name: "Multi-Family Offices",
    title: "Your Family’s Wealth, Consolidated. Organized. Future-Ready",
    descriptions: [
      "Get consolidated view & reporting across asset classes – equity, mutual funds, PMS, AIF, Bonds, unlisted shares and more.",
      "Seamlessly import data and continuous data sync via broker files and contract notes",
      "Share your investment portfolio with family members accessible via web and mobile apps to maintain transparency and collective decision-making.",
    ],
    imgSrc: "/LandingPage/familyOffice.png",
  },
];
